import request from '@/services/request'

export function fetchAll(data) {
  return request({
    url: process.env.BASE_URL_INVENTORY + '/master-supplier/list',
    method: 'get',
    params: data
  })
}

export function changeStatusItem(data) {
  return request({
    url: process.env.BASE_URL_INVENTORY + '/master-supplier/update-status',
    method: 'put',
    data: data
  })
}

export function get(data) {
  return request({
    url: process.env.BASE_URL_INVENTORY + '/master-supplier/detail',
    method: 'get',
    params: data
  })
}

export function create(data) {
  return request({
    url: process.env.BASE_URL_INVENTORY + '/master-supplier/create',
    method: 'post',
    data: data
  })
}

export function update(data) {
  return request({
    url: process.env.BASE_URL_INVENTORY + '/master-supplier/update',
    method: 'put',
    data: data
  })
}

export function getMasterSupplierList() {
  return request({
    url: process.env.BASE_URL_INVENTORY + '/master-supplier/common-list',
    method: 'get'
  })
}





// WEBPACK FOOTER //
// ./src/api/master_supplier.js